import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { AppContainer } from "react-hot-loader";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import OnDOMReady from "shared/util/OnDOMReady";

import reducers from "./reducers";
import analyticsMiddleware from "./analyticsMiddleware";
import App from "./App";

let store;
let renderForHotReload;

OnDOMReady(() => {
	store = createStore(
		reducers,
		compose(
			applyMiddleware(thunk, analyticsMiddleware),
			window.__REDUX_DEVTOOLS_EXTENSION__ ?
				window.__REDUX_DEVTOOLS_EXTENSION__({ name: "ENTRYJS", id: "ENTRYJS" }) :
				(f) => f,
		),
	);

	renderForHotReload = (Component, data) => {
		render(
			<Provider store={data}>
				<AppContainer>
					<Component />
				</AppContainer>
			</Provider>,
			document.getElementById("root"),
		);
	};

	renderForHotReload(App, store);
});

if (module.hot) {
	module.hot.accept("./App", () => { renderForHotReload(App, store); });
}



// WEBPACK FOOTER //
// ./src/pages/discovery/index.js